// Using an item (decision 0053: consumables; a cooked dish's short buff, a tonic's healing over time): one is taken from
// the inventory and each of its `use` effects is applied to a character's ability state. All or nothing: an item that
// can't be used, isn't held, or whose effect the target refuses (its tag requirements) is not spent.
import type { AbilitySet, AbilityState } from "@rpg/abilities";
import type { Inventory, InventoryState } from "./inventory";
import type { ItemTable } from "./items";

/** Why an item wasn't used. */
export type UseRefusal = "unknown" | "unusable" | "none" | "refused";

/** Use one of an item on a character: its effects applied (source: `source`), one taken. Null on success. */
export function useItem(o: { items: ItemTable; inventory: Inventory; inv: InventoryState; set: AbilitySet; stats: AbilityState; item: string; source?: number | null }): UseRefusal | null {
  if (!o.items.has(o.item)) return "unknown";
  const effects = o.items.get(o.item).use ?? [];
  if (!effects.length) return "unusable";
  if (o.inventory.count(o.inv, o.item) < 1) return "none";
  // try on a copy first, so a refused effect spends nothing
  const trial = structuredClone(o.stats);
  for (const e of effects) if ("refused" in o.set.apply(trial, e, { source: o.source ?? null })) return "refused";
  for (const e of effects) o.set.apply(o.stats, e, { source: o.source ?? null });
  o.inventory.take(o.inv, o.item, 1);
  return null;
}
